import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { deepLinkMailModuleRouteHandler } from './deepLinkMailModuleRouteHandler';
import { deepLinkInboxForMeRouteHandler } from './deepLinkInboxForMeRouteHandler';
import { deepLinkSproutRouteHandler } from './deepLinkSproutRouteHandler';
import getCurrentDeepLinkRoute from './getCurrentDeepLinkRoute';
import type { RegisterRouteFunction, RouterOptions } from 'owa-router';
import deepLinkAttachmentRouteHandler, {
    deepLinkInternetMessageIdAttachmentRouteHandler,
} from './deepLinkAttachmentRouteHandler';
import {
    deepLinkComposeRouteHandler,
    deepLinkReplyRouteHandler,
    deepLinkReplyAllRouteHandler,
    deepLinkComposeDraftRouteHandler,
} from './deepLinkComposeRouteHandler';
import deepLinkItemAttachmentRouteHandler from './deepLinkItemAttachmentRouteHandler';
import { deepLinkSearchAnswerRouteHandler } from './deepLinkSearchAnswerRouteHandler';
import { deepLinkSaveToCloudRouteHandler } from './deepLinkSaveToCloudRouteHandler';
import { deepLinkPeoplePickerRouteHandler } from './deepLinkPeoplePickerRouteHandler';
import { deepLinkDownloadMobileRouteHandler } from './deepLinkDownloadMobileRouteHandler';
import { inClientStoreRouteHandler } from 'owa-addins-marketplace-routing';

export const getMailRouterOptions = (): RouterOptions => ({
    routeGenerator: Promise.resolve(getCurrentDeepLinkRoute),
    vdir: 'mail',
    defaultRoute: '/deeplink',
    staticUrl: isHostAppFeatureEnabled('routeOptionsStaticUrl'), // don't update the address bar in OPXs
    registerRoutes: initializeDeepLinkMailRoutes,
});

function initializeDeepLinkMailRoutes(registerRoute: RegisterRouteFunction) {
    // Helper function to register a deeplink + OPX version of each route
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7006 (36,34): Parameter 'route' implicitly has an 'any' type.
    // @ts-expect-error
    const registerRouteHelper = (route, onNavigateTo) => {
        registerRoute('/deeplink' + route, onNavigateTo);
        registerRoute('/opxdeeplink' + route, onNavigateTo);
    };

    registerRouteHelper('/searchAnswer', deepLinkSearchAnswerRouteHandler);
    registerRouteHelper('/read/:itemId', deepLinkMailModuleRouteHandler);
    registerRouteHelper('/readonly/:readonlyItemId', deepLinkMailModuleRouteHandler);
    registerRouteHelper(
        '/readimid/:base64EncodedInternetMessageId',
        deepLinkMailModuleRouteHandler
    );
    registerRouteHelper('/readconv/:convId', deepLinkMailModuleRouteHandler);
    registerRouteHelper(
        '/read/group/:groupDomain/:groupAlias/:itemId',
        deepLinkMailModuleRouteHandler
    );
    registerRouteHelper(
        '/readconv/group/:groupDomain/:groupAlias/:convId',
        deepLinkMailModuleRouteHandler
    );
    registerRouteHelper('/compose', deepLinkComposeRouteHandler);
    registerRouteHelper('/compose/reply', deepLinkReplyRouteHandler);
    registerRouteHelper('/compose/reply/:draftId', deepLinkReplyRouteHandler);
    registerRouteHelper('/compose/replyall', deepLinkReplyAllRouteHandler);
    registerRouteHelper('/compose/replyall/:draftId', deepLinkReplyAllRouteHandler);
    registerRouteHelper('/compose/draft', deepLinkComposeDraftRouteHandler);
    registerRouteHelper('/compose/:draftId', deepLinkComposeRouteHandler);
    registerRouteHelper(
        '/internetmessageidattachment/:base64EncodedInternetMessageId/:attachmentIndex',
        deepLinkInternetMessageIdAttachmentRouteHandler
    );
    registerRouteHelper(
        '/attachment/:itemId/:attachmentId/:isEdit',
        deepLinkAttachmentRouteHandler
    );
    registerRouteHelper(
        '/attachment/:itemId/:attachmentId/:isEdit/:startTime',
        deepLinkAttachmentRouteHandler
    );
    registerRouteHelper('/attachment/:itemId/:attachmentId', deepLinkAttachmentRouteHandler);
    // TODO: Remove additional deep link route after Group Card starts using new route
    registerRouteHelper(
        '/attachment/:itemId/:attachmentId/group/:groupDomain/:groupAlias',
        deepLinkAttachmentRouteHandler
    );
    registerRouteHelper(
        '/attachment/group/:groupDomain/:groupAlias/:itemId/:attachmentId',
        deepLinkAttachmentRouteHandler
    );
    registerRouteHelper('/itemattachment/:attachmentId', deepLinkItemAttachmentRouteHandler);

    registerRoute(
        '/deeplink/saveAndEdit/:itemId/:attachmentId/:subscriptionId',
        deepLinkSaveToCloudRouteHandler
    );

    registerRouteHelper('/peoplepicker', deepLinkPeoplePickerRouteHandler);

    registerRouteHelper('/sprout', deepLinkSproutRouteHandler);

    registerRouteHelper('/inboxForMe', deepLinkInboxForMeRouteHandler);

    registerRouteHelper('/downloadmobile', deepLinkDownloadMobileRouteHandler);

    registerRouteHelper('/inclientstore', inClientStoreRouteHandler);

    registerRouteHelper('', deepLinkMailModuleRouteHandler);

    return Promise.resolve();
}
